export function compareNumbers(a, b) {
    if (b === null || b === undefined) {
        return 1;
    }
    if (a === null || a === undefined) {
        return -1;
    }
    return a - b;
}
export function compareStrings(a, b) {
    a = a ? a : '';
    b = b ? b : '';
    return a.localeCompare(b);
}
export function compareBooleans(a, b) {
    var valA = a ? 1 : 0;
    var valB = b ? 1 : 0;
    return valA - valB;
}
export function compareDates(a, b) {
    var valA = a ? a : new Date(Number.NEGATIVE_INFINITY);
    var valB = b ? b : new Date(Number.NEGATIVE_INFINITY);
    return valA.getTime() - valB.getTime();
}
